import Row from 'react-bootstrap/lib/Row';
import Classes from '../../../../common/Classes';
import Col from 'react-bootstrap/lib/Col';
import {ItemType, ImageTypes} from '../../../../common/Constants';
import React from 'react';
import ThumbnailWrapper from './ThumbnailWrapper';
import PropTypes from 'prop-types';
import Utils from '../../../../common/Utils';
import mixpanelConstants from '../../../../common/mixpanelConstants';

const ProductsAndDocumentsWithoutCarousel = (props) => {
    const {
        exhibitorId,
        products,
        documents,
        productsTitle,
        documentsTitle,
        translations,
        getDtmTag
    } = props

    const doDocumentsExist = documents.length > 0;
    const doProductsExists = products.length > 0;
    const productProps = {
        lg:doDocumentsExist ? 5 : 12,
        md:doDocumentsExist ? 5 : 12,
        sm:doDocumentsExist ? 6 : 12,
        className: doDocumentsExist ? 'products-col' : ''
    }
    const documentProps = {
        lg:doProductsExists ? 5 : 12,
        md:doProductsExists ? 5 : 12,
        sm:doProductsExists ? 6 : 12,
        mdOffset:doProductsExists > 0 ? 1 : 0
    }
    const getProductDtmAttributes = (product, exhibitorId) => {
        const attributes = {
            productId: product.id,
            exhibitorId,
            isNew: product.isNew,
        };
        attributes.isVideoAvailable = !!product.videoId;
        return JSON.stringify(attributes);
    }

    return <Row>
        {
            products.length > 0?
                <Col {...productProps}>
                    <h6 className={Classes.productsTitleInDirectory}>{productsTitle}</h6>
                    <div className={Classes.productsContainerWithoutCarousel}>
                        {
                            products.map((product, index)=>(
                                <div key={index} onClick={()=>props.onClick(index, ItemType.Product)}>
                                <ThumbnailWrapper
                                    key={product.id}
                                    src={product.imageUrl}
                                    imageSize={ImageTypes.product}
                                    alt={translations.products.productImageAltText}
                                    translations={translations.products}
                                    imageDataDtm = {{tag:getDtmTag('product'), attributes: getProductDtmAttributes(product, exhibitorId)}}
                                    imageOnClick = {props.onClick}
                                    imageIndex={index}
                                    type={ItemType.Product}
                                    clipText= {product.isNew && translations.products.productCarouselClipText}
                                    innovativeProductClipText={product.isInnovative && translations.products.innovativeClipText}
                                    mixpanelProps={{...props.mixpanelProps, productId: product.id, productName: product.name}}
                                    isVideoAvailable={!!product.videoId}
                                    product={product}
                                />
                                </div>
                            ))
                        }
                    </div>
                </Col>
                : null
        }
        {
            documents.length > 0 ?
                <Col {...documentProps}>
                    <h6 className={Classes.documentsTitleInDirectory}>{documentsTitle}</h6>
                    <div className={Classes.documentsContainerWithoutCarousel}>
                        {
                            documents.map((document, index)=>(
                                <div key={index} onClick={()=>props.onClick(index, ItemType.Document)}>
                                <ThumbnailWrapper
                                    key={index}
                                    src={Utils.getDocumentThumbnail(document.url)}
                                    alt={translations.documents.documentImageAltText}
                                    translations={translations.products}
                                    imageDataDtm = {{
                                        tag: getDtmTag('document'),
                                        attributes: JSON.stringify({
                                            documentName: Utils.removePdfFileNameExtension(document.title),
                                            documentType: document.type, exhibitorId })}}
                                    imageIndex={index}
                                    type={ItemType.Document}
                                    imageOnClick = {props.onClick}
                                    clipText= {document.type && translations.documents.documentType[document.type.toLowerCase()]}
                                    mixpanelProps={{...props.mixpanelProps, documentName: Utils.removePdfFileNameExtension(document.title), documentType: document.type.toLowerCase(), type: mixpanelConstants.type.exhibitor}}
                                />
                                </div>
                            ))
                        }
                    </div>
                </Col>
                : null
        }
    </Row>
}
ProductsAndDocumentsWithoutCarousel.propTypes = {
    exhibitorId:PropTypes.string.isRequired,
    documents: PropTypes.array.isRequired,
    products:PropTypes.array.isRequired,
    productsTitle:PropTypes.string.isRequired,
    documentsTitle:PropTypes.string.isRequired,
    translations:PropTypes.object.isRequired,
    getDtmTag:PropTypes.func.isRequired,
    onClick:PropTypes.func.isRequired,
    mixpanelProps: PropTypes.object,
}
export default ProductsAndDocumentsWithoutCarousel;
